<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Survey Email</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.prevent="updateHomeContent"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="SurveyEmailContent" class="d-block">Message</label>
                                                                <div>
                                                                    <ckeditor id="SurveyEmailContent"
                                                                        v-model="webinarContentData.SurveyEmailContent" :config="editorConfig" >
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.webinarContentData.SurveyEmailContent.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CKEditor from 'ckeditor4-vue';


Vue.use(CKEditor);

export default {
    name: "email_content",
    mixins: [validationMixin],
    data() {
        return {
            webinarContentData: {
                SurveyEmailContent: "",
            },
            editorConfig: { 
                versionCheck: false 
            },
        }
    },
    validations: {
        webinarContentData: {
            SurveyEmailContent: {
                required
            }
        }
    },
    methods: {
        updateHomeContent() {
            this.$v.webinarContentData.$touch();
            if (this.$v.webinarContentData.$anyError) {
                return;
            }
            API.updateHomeContent(this.webinarContentData, this.updateHomeContentCB, this.errorCB)
        },
        updateHomeContentCB(res) {
            this.webinarContentData = res.data;
            this.$showNotification(res, 'success')
        },
        getWebContent() {
            API.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.webinarContentData = res.data;
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getWebContent();
    },
    components: {}
}
</script>
